
import React from 'react';
import { useLocation } from 'react-router-dom';

function Footer(props) {

	const location = useLocation();

	if (!location.pathname.toLowerCase().match(/works\/[0-9]+/) && (location.pathname.toLowerCase() != '/works')) {
		return (
			<footer id="footer" className={props.isSection ? "section sec5 fp-auto-height" : ""}>
				<div className="footer-inner">
					<div className="fR">
						<ul className="company-info">
							<li>Tel.  02-529-2647</li>
							<li>Project request.  aviv@avivland.com</li>
						</ul>
						<a href="https://avivland.com/Policy" className="txt-link" target="_blank">개인정보처리방침</a>
					</div>
					<div className="fL">
						<p>경기도 성남시 분당구 판교역로 221, 투썬월드빌딩 1F 아비브</p>
						<ul className="company-info">
							<li>Tel.  02-529-2647</li>
							<li>Project request.  aviv@avivland.com</li>
						</ul>
						<p>ⓒCopyright all right reserved 2023</p>
					</div>
				</div>
			</footer>
		);
	} else {
		return null;
	}
}

export default Footer;
